import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {APP_MENU_ABOUT} from 'app/core/models/common-ux-types';
import {AboutComponent} from './components/about.component';

const routes: Routes = [
  {
    path: '',
    component: AboutComponent,
    data: {title: APP_MENU_ABOUT},
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AboutRoutingModule {}
